import PageHero from "@/components/site/PageHero";
import PersonProfile from "@/components/site/PersonProfile";
import CTASection from "@/components/site/CTASection";
import { usePageMeta } from "@/components/site/SEO";
import { PEOPLE } from "@/content/people";
import { PEOPLE_INTRO } from "@/content/site";

export default function People() {
  usePageMeta(
    "Our People",
    "Meet the facilitators behind Wandering Glider Experiences: educators, naturalists, artists, athletes and storytellers.",
  );

  return (
    <>
      <PageHero eyebrow="Our People" title="The people behind the journeys" intro={PEOPLE_INTRO} />

      <section className="container-x pb-20 sm:pb-28" data-testid="people-list">
        <div className="grid gap-x-14 gap-y-14 md:grid-cols-2">
          {PEOPLE.map((person, i) => (
            <PersonProfile key={person.id} person={person} index={i} />
          ))}
        </div>
      </section>

      <CTASection
        heading="Come and wander with us"
        primary={{ label: "Start Your Journey", to: "/start-your-journey", testId: "people-start-cta" }}
        secondary={{ label: "Explore Our Journeys", to: "/journeys", testId: "people-journeys-cta" }}
        testId="people-cta"
      />
    </>
  );
}
